<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Yetkinlik</label>
            <v-validator :errors="errors" parameter="EmployeeProficiencyId" :watch="proficiency"> 
                <v-select-list v-model="proficiency" label="Name" placeholder="Yetkinlik" :options="proficiencies"/>
            </v-validator>
        </div>
        <div class="col-12 mb-1">
            <label class="form-label">Değer</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
            <input type="text" v-model="value.Name" class="form-control" placeholder="Şube"/>
            </v-validator>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.IsDefaultValue">Varsayılan</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import VValidator from '@/components/VValidator.vue'
export default {
    components:{
        BFormCheckbox,
        VValidator
    },
    props:{
        value:Object,
        errors:Object
    },
    data(){
        return{
            proficiencies:[],
        }
    },
    mounted(){
        this.getProficiencies();
    },
    methods:{
        getProficiencies(){
            HumanResourcesParameterApi.EmployeeProficiency.List().then(res=>{
                this.proficiencies = res.data.Data
            })
        },
    },
    computed:{
        proficiency:{
            get:function(){
                return this.proficiencies.find(b=>b.Id==this.value.EmployeeProficiencyId)
            },
            set:function(value){
                this.value.EmployeeProficiencyId = value?.Id || null
            }
        }
    },
}
</script>

<style lang="scss">
</style>